import React from "react";
import styled from "styled-components";
import ImageTarget01 from "../../assets/images/img-target-01.png";
import ImageTarget01_01 from "../../assets/images/img-target-01.png";
import ImageTarget02 from "../../assets/images/img-target-02.png";
import ImageTarget03 from "../../assets/images/img-target-03.png";
import GridItem from "./Layout/GridItem";
import InnerSection from "./Layout/InnerSection";
import Section from "./Layout/Section";
import ThreeColumnGrid from "./Layout/ThreeColumnGrid";
import SubTitle from "./Text/SubTitle";
import TextBlock from "./Text/TextBlock";
function TargetContainer({ children }) {
  return (
    <Section padding="100px 0" id="page6">
      <InnerSection>
        <SubTitle fontSize="40" data-aos="fade-up" data-aos-duration="1000">
          모시러 채용/파견 상품
        </SubTitle>
        <ColumnGrid>
          <GridItem data-aos="fade-up" data-aos-duration="1000">
            <TargetImage src={ImageTarget01_01} alt="icon" />
            <ItemTitle textAlign="center">
              채용 (헤드헌팅)
            </ItemTitle>
            <TextBlock fontSize="16" textAlign="center">
              모시러에서 직접 교육 및 인터뷰를 진행한<br />
              수행기사를 고용해 보세요.
            </TextBlock>
          </GridItem>
          <GridItem
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="50"
          >
            <TargetImage src={ImageTarget02} alt="icon" />
            <ItemTitle textAlign="center">
              파견
            </ItemTitle>
            <TextBlock fontSize="16" textAlign="center">
              다년간 모시러에서 고객님들께 서비스를 제공해 온<br />
              파트너들을 안정적으로 이용해보세요.
            </TextBlock>
          </GridItem>
          {/* <GridItem
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            <TargetImage src={ImageTarget03} alt="icon" />
            <TextBlock fontSize="16" textAlign="center">
              개인 사생활 노출 없이 <br />
              자유롭게 이용하고 싶은 고객
            </TextBlock>
          </GridItem> */}
        </ColumnGrid>
      </InnerSection>
    </Section>
  );
}
const TargetImage = styled.img`
  display: block;
  width: 378px;
  max-width: 100%;
  margin: 0 auto 29px;
  @media (max-width: 640px) {
    width: 100%;
    margin: 0 auto 16px;
  }
`;
const ColumnGrid = styled(ThreeColumnGrid)`
  margin-top: 53px;
  @media (max-width: 640px) {
    margin-top: 24px;
  }
`;
const ItemTitle = styled(TextBlock).attrs({
  fontWeight: `bold`,
  fontSize: `24`,
})`
  margin-bottom: 12px;
`;
export default TargetContainer;
